module.exports = __webpack_public_path__ + "static/media/bg32.30b2841b.jpg";